export default function CapeCoralHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Cape%20Coral%20Florida%20waterfront%20community%20at%20golden%20hour%2C%20the%20city%20of%20canals%20with%20beautiful%20waterways%20winding%20through%20residential%20neighborhoods%2C%20modern%20waterfront%20homes%20with%20private%20docks%20and%20boats%2C%20palm%20trees%20and%20tropical%20landscaping%2C%20warm%20sunset%20light%20reflecting%20on%20calm%20aquamarine%20water%2C%20the%20Sunshine%20Bridge%20visible%20in%20the%20distance%2C%20professional%20drone%20photography%20with%20rich%20warm%20colors%20and%20dramatic%20sky%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=capecoral-hero-img&orientation=landscape"
        alt="Cape Coral Florida canals and waterfront homes at golden hour"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 text-center">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Emergency &amp; Expedited Passport Services in Cape Coral, FL
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
          Cape Coral canal-front homeowner with a sailing trip to the Bahamas next week and your passport expired? Waterfront retiree whose European summer vacation is booked for June? Family with a Caribbean cruise departing from Miami in two weeks and you just realized everyone's passports are out of date? We help Cape Coral residents — from canal-front boaters to waterfront retirees to families in the fastest-growing city in Southwest Florida — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30&ndash;100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.
        </p>
        <a
          href="https://fastpassportcenter.com/checkout/"
          className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
        >
          Start My Passport <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
            </div>
            <span className="font-semibold">4.9 / 5</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-award-line text-[#F6C344] text-base"></i>
            <span>A+ BBB Rating</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-calendar-check-line text-[#F6C344] text-base"></i>
            <span>20+ Years</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-[#F6C344] text-base"></i>
            <span>Registered State Dept. Courier</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-price-tag-3-line text-[#F6C344] text-base"></i>
            <span>Best Price Guarantee</span>
          </div>
        </div>
      </div>
    </section>
  );
}